import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a fast view for table registration.
 * @extends JetView
 */
export default class tableRegisterFastView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Main view type
            id: 'datatable', // Unique identifier for the datatable
            select: true, // Enable row selection
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            columns: [
                // Column definitions for the datatable
                {
                    id: 'ActionTittle', // Column ID
                    header: '', // Column header
                    width: 100, // Column width
                    height: 25, // Column height
                    tooltip: 'Acción', // Tooltip text
                    template: function (obj) {
                        // Template function for rendering cell content
                        return "<span placeholder='Aprobar' class='webix_icon wxi-close printer'></span>"; // Icon for action
                    },
                },
                {
                    id: 'NroCheck', // Column ID
                    header: _('Nro Cheque'), // Localized column header
                    width: 200, // Column width
                    sort: 'int', // Sorting type
                },
                { id: 'Client', header: _('Cliente'), width: 200, sort: 'int' }, // Client column
                {
                    id: 'DocClient', // Document Client column
                    header: _('Doc. Cliente'), // Localized header
                    width: 150, // Column width
                    sort: 'int', // Sorting type
                },
                { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' }, // Date column
                { id: 'Origin', header: _('Origen'), width: 150, sort: 'int' }, // Origin column
                {
                    id: 'ReferenceDocument', // Reference Document column
                    header: _('Documento Referente'), // Localized header
                    width: 200, // Column width
                    sort: 'int', // Sorting type
                },
                { id: 'Value', header: _('Valor'), width: 200, sort: 'int' }, // Value column
                {
                    id: 'Currency', // Currency column
                    header: _('Moneda'), // Localized header
                    width: 200, // Column width
                    sort: 'int', // Sorting type
                },
            ],
            onClick: {
                // Event handler for click events
                printer: function (euv, id) {
                    // Function to handle printing action
                    var item = this.getItem(id); // Get the clicked item
                    var vvthis = this; // Reference to the current context
                    webix // AJAX request to fetch PDF
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Set content type for the request
                        })
                        .post(
                            devConfig.geturlApi() + // API URL
                                'es/UserManagement/GetReprintCheckPDF',
                            '{"NroCheck":"' + item.NroCheck + '"}', // Request body
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    // Error handling
                                    webix.message('Error! '); // Display error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    // Success handling
                                    data = JSON.parse(text); // Parse response data
                                    if (!data.HasError) {
                                        // Check for errors in response
                                        webix // Create a window to display the PDF
                                            .ui({
                                                view: 'window',
                                                width: 500,
                                                height: 700,
                                                head: {
                                                    view: 'toolbar',
                                                    cols: [
                                                        {
                                                            view: 'label',
                                                            label: _('Factura'), // Label for the window
                                                        },
                                                        {
                                                            view: 'button',
                                                            label: 'X', // Close button
                                                            width: 100,
                                                            align: 'right',
                                                            click: "$$('windowfact2').close();", // Close action
                                                        },
                                                    ],
                                                },
                                                id: 'windowfact2', // Window ID
                                                modal: true, // Modal window
                                                position: 'center', // Center position
                                                body: {
                                                    rows: [
                                                        {
                                                            template:
                                                                '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Iframe for PDF display
                                                        },
                                                    ],
                                                },
                                            })
                                            .show(); // Show the window
                                        var reader = new FileReader(); // FileReader to read the PDF data
                                        reader.onload = function (event) {
                                            // On load event
                                            $$('pdf').clear(); // Clear previous PDF data
                                            $$('pdf').parse({
                                                data: event.target.result, // Parse new PDF data
                                            });
                                        };
                                        /**
                                         * Converts base64 string to Blob object.
                                         * @param {string} b64Data - Base64 encoded data.
                                         * @param {string} contentType - MIME type of the content.
                                         * @param {number} sliceSize - Size of each slice.
                                         * @returns {Blob} The Blob object.
                                         */
                                        function b64toBlob(b64Data, contentType, sliceSize) {
                                            contentType = contentType || ''; // Default content type
                                            sliceSize = sliceSize || 512; // Default slice size
                                            var byteCharacters = atob(b64Data); // Decode base64 string
                                            var byteArrays = []; // Array to hold byte arrays
                                            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                                                var slice = byteCharacters.slice(offset, offset + sliceSize); // Slice the byte characters
                                                var byteNumbers = new Array(slice.length); // Array for byte numbers
                                                for (var i = 0; i < slice.length; i++) {
                                                    byteNumbers[i] = slice.charCodeAt(i); // Convert to byte numbers
                                                }
                                                var byteArray = new Uint8Array(byteNumbers); // Create Uint8Array from byte numbers
                                                byteArrays.push(byteArray); // Add to byte arrays
                                            }
                                            var blob = new Blob(byteArrays, {
                                                type: contentType, // Create Blob with content type
                                            });
                                            return blob; // Return the Blob object
                                        }
                                        var contentType = 'application/pdf'; // PDF content type
                                        var b64Data = data.Pdf; // Base64 PDF data
                                        var blob = b64toBlob(
                                            b64Data,
                                            contentType, // Convert to Blob
                                        );
                                        var file = window.URL.createObjectURL(blob); // Create object URL for the Blob
                                        document.querySelector('iframe').src = file; // Set iframe source to the Blob URL
                                        var printWindow = window.open(
                                            file,
                                            '',
                                            'width=800,height=500', // Open print window
                                        );
                                        printWindow.print(); // Trigger print dialog
                                    }
                                },
                            },
                        );
                },
            },
            footer: false, // Disable footer
            math: true, // Enable math calculations
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        var url = devConfig.geturlApi() + 'es/UserManagement/GetTableReprintCheck'; // API URL for fetching data
        this.on(this.app, 'reprintCheck:filter', (filterData) => {
            // Event listener for filtering data
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add filter to query
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', ''); // Remove time from date
                                string1 = string1 + '&dateFrom=' + date; // Add date to query
                                string1 = string1 + '&dateTo=' + date; // Add date to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format date
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format date
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            $$('filterPopup').hide(); // Hide filter popup
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event listener for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
